module.exports = __webpack_public_path__ + "static/media/paraflux-logo.45eee287.png";